import Cookies from "js-cookie";
import { BASE_URL } from "./connectionUrl";
const authStaging = Cookies.get("authStaging")
  ? JSON.parse(Cookies.get("authStaging"))
  : null;
const token = authStaging?.token || "";

export const saveOldPatientAppointment = async (appointment, id) => {
  //save old appointments
  const url = `${BASE_URL}/api/v1/patients/${id}`;
  try {
    const res = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(appointment),
    });

    const data = await res.json();
    return data;
  } catch (error) {
    return { error, msg: error.message };
  }
};

export const updatePatientAppointment = async (appointment, id) => {
  //save appointments
  const url = `${BASE_URL}/api/v1/appointments/${id}`;
  try {
    const res = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(appointment),
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return { error, msg: error.message };
  }
};

export const pinPatientAppointment = async (id) => {
  // for pin patient
  const url = `${BASE_URL}/api/v1/appointments/${id}/pin`;
  try {
    const res = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await res.json();
    return data;
  } catch (error) {
    return { error, msg: error.message };
  }
};

export const updateAiSummary = async (payload) => {
  const url = `${BASE_URL}/api/v1/prescriptions/update_ai_summary`;
  try {
    const res = await fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return { error, msg: error.message };
  }
};

export const updateMasterData = async (type, id, updatedData) => {
  const url = `${BASE_URL}/api/v1/master/save_spelling?type=${type}&id=${id}`;
  try {
    const res = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(updatedData),
    });

    const data = await res.json();
    return data;
  } catch (error) {
    return { error, msg: error.message };
  }
};

export const cancelAppointment = async (id) => {
  const url = `${BASE_URL}/api/v1/appointments/${id}/${"cancel"}`;
  try {
    const res = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return { error, msg: error.message };
  }
};

export const removeInvestigation = async (appointmentId, test) => {
  const url = `${BASE_URL}/api/v1/appointments/${appointmentId}/remove_investigations?test=${test}`;
  try {
    const res = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return { error, msg: error.message };
  }
};

export const referrerUpdate = async (id, payload) => {
  const url = `${BASE_URL}/api/v1/referrers/${id}`;
  try {
    const res = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return { error, msg: error.message };
  }
};

// billing  put requests

export const putRefundMoney = async (id) => {
  const url = `${BASE_URL}/api/v1/invoices/${id}/refund`;
  try {
    const res = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return { error, msg: error.message };
  }
};

export const putPurchaseOrder = async (payload, id) => {
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/pharmacy/purchase_orders/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify(payload),
      },
    );

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.error(data?.status?.message || "something went wrong");
      return data;
    }
  } catch (error) {
    console.error(error.message || "something went wrong");
  }
};

export const updateSupplier = async (payload, id) => {
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/pharmacy/suppliers/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify(payload),
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.error(data?.status?.message || "something went wrong");
      return data;
    }
  } catch (error) {
    console.error(error.message || "something went wrong");
  }
};

export const updateMedicine = async (payload, id) => {
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/pharmacy/medicines/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify(payload),
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.error(data?.status?.message || "something went wrong");
      return data;
    }
  } catch (error) {
    console.error(error.message || "something went wrong");
  }
};

export const updateMedicineBatch = async (payload, id) => {
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/pharmacy/medicine_batches/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify(payload),
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.error(data?.status?.message || "something went wrong");
      return data;
    }
  } catch (error) {
    console.error(error.message || "something went wrong");
  }
};

export const handleEnableDisableMedicalTest = async (id, type) => {
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/medical_tests/${id}/disable?active=${type}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        // body: JSON.stringify(payload),
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.error(data?.status?.message || "something went wrong");
      return data;
    }
  } catch (error) {
    console.error(error.message || "something went wrong");
  }
};

export const putUpdateMedicalTest = async (payload, id) => {
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/medical_tests/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify(payload),
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.error(data?.status?.message || "something went wrong");
      return data;
    }
  } catch (error) {
    console.error(error.message || "something went wrong");
  }
};

export const putUpdateMedicineSalt = async (payload, id) => {
  try {
    const response = await fetch(
      `${BASE_URL}/api/v1/pharmacy/medicine_salts/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify(payload),
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.error(data?.status?.message || "something went wrong");
      return data;
    }
  } catch (error) {
    console.error(error.message || "something went wrong");
  }
};

export const pharmacyUpdateBill = async (payload) => {
  const url = `${BASE_URL}/api/v1/pharmacy/update_bill`;
  try {
    const res = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const editPharmacyPatient = async (payload) => {
  try {
    const response = await fetch(`${BASE_URL}/api/v1/pharmacy/edit_patient`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.error(data?.status?.message || "something went wrong");
      return data;
    }
  } catch (error) {
    console.error(error.message || "something went wrong");
  }
};

export const updateDosage = async (payload, id) => {
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/admin/medicine_descriptions/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify(payload),
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.error(data?.status?.message || "something went wrong");
      return data;
    }
  } catch (error) {
    console.error(error.message || "something went wrong");
  }
};

export const updateTestShortCode = async (payload, id) => {
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/admin/medical_test_shortcodes/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify(payload),
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.error(data?.status?.message || "something went wrong");
      return data;
    }
  } catch (error) {
    console.error(error.message || "something went wrong");
  }
};

export const upDateDiagnosis = async (payload, id) => {
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/admin/diagnosis/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify(payload),
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.error(data?.status?.message || "something went wrong");
      return data;
    }
  } catch (error) {
    console.error(error.message || "something went wrong");
  }
};

export const updateSpecialInst = async (payload, id) => {
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/admin/special_instructions/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify(payload),
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.error(data?.status?.message || "something went wrong");
      return data;
    }
  } catch (error) {
    console.error(error.message || "something went wrong");
  }
};

export const updateMedicineRemarks = async (payload, id) => {
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/admin/medicine_remarks/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify(payload),
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.error(data?.status?.message || "something went wrong");
      return data;
    }
  } catch (error) {
    console.error(error.message || "something went wrong");
  }
};

export const updateFollowUps = async (payload, id) => {
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/admin/followup_lists/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify(payload),
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.error(data?.status?.message || "something went wrong");
      return data;
    }
  } catch (error) {
    console.error(error.message || "something went wrong");
  }
};

export const updateTreatments = async (payload, id) => {
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/admin/treatments/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify(payload),
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.error(data?.status?.message || "something went wrong");
      return data;
    }
  } catch (error) {
    console.error(error.message || "something went wrong");
  }
};

export const updateQueryStatus = async (payload, id) => {
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/queries/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify(payload),
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.error(data?.status?.message || "something went wrong");
      return data;
    }
  } catch (error) {
    console.error(error.message || "something went wrong");
  }
};

export const updateJointAssessment = async (
  existingReportId,
  report_assessment,
) => {
  const url = `${BASE_URL}/api/v1/report_assessments/${existingReportId}`;
  try {
    const res = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify({ report_assessment }),
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const updateExternalMed = async (
  existingReportId,
  external_medication,
) => {
  const url = `${BASE_URL}/api/v1/external_medications/${existingReportId}`;
  try {
    const res = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify({ external_medication }),
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const linkInvoiceToPatient = async (invoiceId, patientId) => {
  const url = `${BASE_URL}/api/v1/invoices/${invoiceId}/link_patient`;
  try {
    const res = await fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify({ patient_id: patientId }),
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return { error, msg: error.message };
  }
};
